import axios from 'axios';
import Vue from 'vue';
import alertify from 'vue-alertify';
import Keycloak from 'keycloak-js';
import VueJwtDecode from 'vue-jwt-decode';
import apiUrl from '../constants'
Vue.use(alertify);

let initOptions = {
  url: apiUrl.keycloakUrl, realm: 'xpressbees', clientId: apiUrl.authclientidui , onLoad: 'login-required'
}

let keycloak = new Keycloak(initOptions);

const Alertify = new Vue();

export default function setup() {
  axios.interceptors.request.use(function(config) {

    const userAccessToken = window.localStorage.getItem('access_token')
    const token = userAccessToken? userAccessToken.replace(/"/g, '') : false;
    
    // config.headers.Authorization ? 
    config.headers.Authorization = `Bearer ${token}` 
    // : config.headers.authorization = `Bearer ${token}`;
    
    // if(token) {
    //   (config.headers.Authorization) ? config.headers.Authorization = `Bearer ${token}` : config.headers.authorization = `Bearer ${token}`;
    // }
    config.headers['Strict-Transport-Security'] = `max-age=31536000; includeSubDomains; preload`;
    config.headers['X-Content-Type-Options'] = 'nosniff';
    config.headers['X-Frame-Options'] = 'sameorigin';
    config.headers['Content-Security-Policy'] = `default-src 'self'`;
    // config.headers['Access-Control-Allow-Headers'] =  '*'
    // config.headers['Access-Control-Allow-Origin'] = '*'  
    // console.log(config)
    return config;

  }, function(err) {

    console.log('interceptors err==', err);
    return Promise.reject(err);
  });

  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    async function (error) {
      console.log("Axios Interceptor Error:", error);
      if (error.response) {
        const { status } = error.response;
        console.log(`HTTP Error ${status}: ${error.response.statusText}`);

        if (status === 401) {
          console.log("Token Expired - Logging out");
  
          sessionStorage.clear();
          localStorage.clear();

          // keycloak.logout({ redirectUri: `${apiUrl.app_url}` });
          window.location.href = `${apiUrl.app_url}`
          return Promise.reject("Session expired. Redirecting to login.");
        }

        if (status === 405) {
          console.log("405 Method Not Allowed: Missing allowed origin header in preflight request.");
        }
      } 
      else if (error.request) {
        console.log("No response received from server:", error.request);
        Alertify.$alertify.error("Token Validation error");
  
        // keycloak.logout({ redirectUri: `${apiUrl.app_url}` });
        //window.location.href = `${apiUrl.app_url}`
      } 

      else {
        console.log("Error:", error.message);
      }
  
      return Promise.reject(error);
    }
  );
  



  // axios.interceptors.response.use(function (response) {
    
  //   if(response.status === 401) {
  //       // keycloak.updaterefreshtoken()
  //       console.log("Token Expired")
  //       // keycloak.logoutWithoutTokenId()
  //       // Promise.reject("You are not authorized");
  //       sessionStorage.clear()
  //       keycloak.clearToken()
  //       keycloak.logout({ redirectUri: `${apiUrl.app_url}` })
  //       localStorage.clear();
  //       window.location.href = apiUrl.keycloakUrl + '/realms/xpressbees/protocol/openid-connect/logout?client_id=' + apiUrl.authclientidui + '&post_logout_redirect_uri=' + window.location.href;
      
  //   }
  //   return response;
  //   });

  //   axios.interceptors.response.use(
  //     function(response) {
          
  //         return response;
  //     }, 
  //     async function(error) {
  //       console.log(error)
          
  //         if (error.response) {
           
  //           if (error.response.status === 405) {
  //               console.log('405 Method Not Allowed: Missing allowed origin header in preflight request.');
  //           } else {
  //               console.log(`Error ${error.response.status}: ${error.response.statusText}`);
  //           }
  //           } else if (error.request) {
               
  //               console.log('No response received:', error.request);
  //               Alertify.$alertify.error('Token Validation error')
  //               const logoutUrl = `${apiUrl.keycloakUrl}/realms/xpressbees/protocol/openid-connect/logout`;
  //               const keycloak = Vue.prototype.$keycloak;
  //               keycloak.logout();
          
  //               // keycloak.logout({ redirectUri: `${apiUrl.app_url}` })
                
  //           } else {
               
  //               console.log ('Error', error.message);
  //           }
  //         return Promise.reject(error);
  //     }
  // );
  
};



// WEBPACK FOOTER //
// ./src/config-keycloak/interceptors.js